import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  recentlyViewedData: [],
  requestRecentlyViewed: false,
  responseRecentlyViewed: false,
  failedRecentlyViewed: false,
  errorRecentlyViewed: {},
  isMobileSearchDrawerVisible: false,
  productsTagAttr: {},
  isNavigating: false,
  allGiftsActiveTab: "",
  allGiftsActiveMenu: "",
  allGiftsActiveSubMenu: "",
};

export const CommonSlice = createSlice({
  name: "common",
  initialState,
  reducers: {
    requestToFetchRecentlyViewedAction: (state) => {
      return {
        ...state,
        requestRecentlyViewed: true,
      };
    },
    responseFromFetchRecentlyViewedAction: (state, action) => {
      return {
        ...state,
        responseRecentlyViewed: true,
        recentlyViewedData: action?.payload,
      };
    },
    failedToFetchRecentlyViewedAction: (state, action) => {
      return {
        ...state,
        failedRecentlyViewed: true,
        errorRecentlyViewed: action.payload,
      };
    },
    setIsMobileSearchVisibleAction: (state, action) => {
      return {
        ...state,
        isMobileSearchDrawerVisible: action.payload,
      };
    },
    setProductTagAttr: (state, action) => {
      return {
        ...state,
        productsTagAttr: action.payload,
      };
    },
    setIsNavigatingAction: (state, action) => {
      return {
        ...state,
        isNavigating: action.payload,
      };
    },
    setAllGiftsActiveTab: (state, action) => {
      return {
        ...state,
        allGiftsActiveTab: action.payload,
      };
    },
    setAllGiftsActiveMenu: (state, action) => {
      return {
        ...state,
        allGiftsActiveMenu: action.payload,
      };
    },
    setAllGiftsActiveSubMenu: (state, action) => {
      return {
        ...state,
        allGiftsActiveSubMenu: action.payload,
      };
    },
  },
});

export default CommonSlice.reducer;
export const {
  failedToFetchRecentlyViewedAction,
  requestToFetchRecentlyViewedAction,
  responseFromFetchRecentlyViewedAction,
  setIsMobileSearchVisibleAction,
  setProductTagAttr,
  setIsNavigatingAction,
  setAllGiftsActiveTab,
  setAllGiftsActiveMenu,
  setAllGiftsActiveSubMenu,
} = CommonSlice.actions;
